/**
 * Internal Clerk resource in play (sign-in vs sign-up). The UI is
 * identifier-first — this only picks which OTP / setActive API to call.
 */
export type AuthMode = "signIn" | "signUp";

export const AUTH_MODE_STORAGE_KEY = "raas.consumerAuth.mode";

export function persistAuthMode(mode: AuthMode): void {
  try {
    sessionStorage.setItem(AUTH_MODE_STORAGE_KEY, mode);
  } catch {
    // private mode / blocked storage
  }
}

export function readAuthMode(): AuthMode {
  try {
    const raw = sessionStorage.getItem(AUTH_MODE_STORAGE_KEY);
    if (raw === "signIn" || raw === "signUp") return raw;
  } catch {
    // ignore
  }
  return "signIn";
}

export function clearAuthMode(): void {
  try {
    sessionStorage.removeItem(AUTH_MODE_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function bindingMessageKey(): "auth.binding" {
  return "auth.binding";
}
